export const formatPrice = (price: number | false) => {
  if (price === false) return '--';
  return price.toFixed(2);
};
